export function setField<T, K extends keyof T>(o: T, key: K, value: T[K]) {
  o[key] = value;
}
/**
 * 判断是否为空
 */
export const validatenull = (val: unknown): val is null => {
  if (typeof val === "boolean") {
    return false;
  }
  if (typeof val === "number") {
    return false;
  }
  if (val instanceof Array) {
    if (val.length == 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === "{}") return true;
  } else {
    if (
      val == "null" ||
      val == null ||
      val == "undefined" ||
      val == undefined ||
      val == ""
    )
      return true;
    return false;
  }
  return false;
};
export const cardType = [
  { label: "身份证", value: "ID_CARD_FRONT" },
  { label: "身份证", value: "ID_CARD_BACK" },
  { label: "银行卡", value: "BANK_CARD" },
  { label: "营业执照", value: "BUSINESS_LICENSE" },
  { label: "组织机构代码证", value: "ORGANIZATION_CODE" },
  { label: "银行开户许可证", value: "POLICY_BANK_PERMIT_CERTIFICATE" },
  { label: "法人身份证", value: "JURIDICAL_PERSON_ID_CARD" },
  { label: "其他", value: "COMPANY_OTHER" },
  { label: "其他", value: "PERSONAL_OTHER" },
];
export const getAssetsFile = (url: string) => {
  console.log("url", url);
  console.log(
    "new URL(`../assets/image/${url}`,import.meta.url)",
    new URL(`../assets/image/${url}`, import.meta.url)
  );
  return new URL(`../assets/image/${url}`, import.meta.url).href;
};
export const isMatchPwd = (password: string) => {
  if (password.length < 8 || password.length > 18) {
    return false;
  }
  //8-18位并且同时包含数字、字母、特殊字符
  const regex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,18}$/);
  if (!regex.test(password)) {
    return false;
  }
  return true;
};
export const tabsPageBase = {
  pageSize: 3,
};

//下载模板+导出 excel
export function download(url: string, fileName: string) {
  const userInfo = sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo") || "")
    : "";
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest(); //定义http请求对象
    xhr.open("GET", url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader(
      "token",
      localStorage.getItem(`token:${userInfo?.id}`) || ""
    );
    xhr.send();
    xhr.responseType = "blob"; // 返回类型blob
    xhr.onload = function () {
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      if (this.status === 200) {
        // console.log(this)
        const blob = this.response;
        const reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          // console.log(e) //查看有没有接收到数据流
          // 转换完成，创建一个a标签用于下载
          const link = document.createElement("a");
          link.setAttribute("download", fileName); //自定义下载文件名称
          link.href = e.target?.result as string
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve(true);
        };
      } else {
        reject(false);
      }
    };
  });
}
